import React from 'react'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Context } from 'chartjs-plugin-datalabels';
import { Pie } from 'react-chartjs-2'

import {
  Grid,
  CardChart,
  FakeCaption,
} from 'components'
import { SPACING } from 'utils'
import { IPizzaReportResponse } from 'services/GST/Dashboard'
import { COLORS, FORMAT } from 'utils'

ChartJS.register(ArcElement, Tooltip, Legend)

interface IPieViewProps {
  data: IPizzaReportResponse
}

const GRAPH_COLORS = [COLORS.blueFonts, COLORS.error] as [string, string]

const PieView: React.FC<IPieViewProps> = ({
  data
}) => {
  const formatPercentage = (value: number, ctx: Context): string => {
    let sum = 0
    const chartData = ctx.chart.data.datasets[0].data.map(valor => String(valor))
    chartData.map((data: string) => { sum += parseInt(data) })

    const percentage = (value * 100 / sum).toFixed(0) + "%"

    return percentage
  }

  return (
    <Grid
      gridCols="1fr 1fr 1fr"
      gridGap={`0 ${SPACING.spacing20}`}
      margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
    >
      <CardChart titleCard="DOCUMENTOS">
        <Pie
          typeof='pie'
          data={{
            datasets: [
              {
                backgroundColor: GRAPH_COLORS,
                data: [data?.qtDocumentosRegulares, data?.qtDocumentosIrregulares]
              }
            ],
            labels: [`REGULARES: ${data?.qtDocumentosRegulares}`, `IRREGULARES: ${data?.qtDocumentosIrregulares}`]
          }}
          options={{
            plugins: {
              datalabels: {
                color: '#fff',
                font: {
                  size: 18
                },
                formatter: formatPercentage,
              },
              legend: {
                display: true,
                position: 'bottom',
              }
            }
          }}
        />
        <FakeCaption
          title={`TOTAL: ${data?.qtDocumentosRegulares + data?.qtDocumentosIrregulares}`}
          color={COLORS.success}
        />
      </CardChart>
      <CardChart titleCard="FORNECEDORES">
        <Pie
          typeof='pie'
          data={{
            datasets: [
              {
                backgroundColor: GRAPH_COLORS,
                data: [data?.qtFornecedorRegular, data?.qtFornecedorIrregular]
              }
            ],
            labels: [`REGULARES: ${data?.qtFornecedorRegular}`, `IRREGULARES: ${data?.qtFornecedorIrregular}`]
          }}
          options={{
            plugins: {
              datalabels: {
                color: '#fff',
                font: {
                  size: 18
                },
                formatter: formatPercentage,
              },
              legend: {
                display: true,
                position: 'bottom',
              }
            }
          }}
        />
        <FakeCaption
          title={`TOTAL: ${data?.qtFornecedorRegular + data?.qtFornecedorIrregular}`}
          color={COLORS.success}
        />
      </CardChart>
      <CardChart titleCard="VALOR DE RISCO">
        <Pie
          typeof='pie'
          data={{
            datasets: [
              {
                backgroundColor: GRAPH_COLORS,
                data: [data?.vlRiscoSemIntervencao, data?.vlRiscoComIntervencao]
              }
            ],
            labels: [`SEM INTERVENÇÃO: ${FORMAT.currency(data?.vlRiscoSemIntervencao)}`, `COM INTERVENÇÃO: ${FORMAT.currency(data?.vlRiscoComIntervencao)}`]
          }}
          options={{
            plugins: {
              datalabels: {
                color: '#fff',
                borderColor: 'green',
                font: {
                  size: 18
                },
                formatter: formatPercentage,
              },
              legend: {
                display: true,
                position: 'bottom',
              }
            }
          }}
        />
      </CardChart>
    </Grid>
  )
}

export default PieView
